module.exports = __webpack_public_path__ + "img/client-12.5b0343d2.webp";